(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-shell"]) return;
  try {
    
  (() => {
    if (window.rrCinematicReady) return;
    window.rrCinematicReady = true;
    const root = document.documentElement;
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let motion = !motionQuery.matches && !navigator.connection?.saveData;
    const players = new Map();
    const setButton = (video, playing) => {
      const button = video.parentElement.querySelector('[data-rr-film-toggle]');
      if (!button) return;
      button.classList.toggle('is-playing', playing);
      button.querySelector('.rr-film-label').textContent = playing ? button.dataset.pause : button.dataset.play;
    };
    const play = async video => {
      if (!video.dataset.loaded) {
        video.src = window.matchMedia('(max-width: 749px)').matches ? video.dataset.srcMobile : video.dataset.src;
        video.dataset.loaded = 'true';
        video.muted = true;
        video.load();
      }
      try { await video.play(); } catch { setButton(video, false); }
    };
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = players.get(entry.target);
        if (!state) return;
        state.visible = entry.isIntersecting;
        if (state.visible && motion && !state.userPaused && !document.hidden) play(entry.target);
        else entry.target.pause();
      });
    }, { threshold: .2 });
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
    }), { threshold: .08 });
    const applyMotion = () => {
      root.dataset.rrMotion = motion ? 'on' : 'off';
      document.querySelectorAll('[data-rr-motion-toggle]').forEach(button => {
        button.textContent = motion ? button.dataset.on : button.dataset.off;
        button.setAttribute('aria-pressed', String(motion));
      });
      players.forEach((state,video) => { if (motion && state.visible && !state.userPaused && !document.hidden) play(video); else video.pause(); });
    };
    const init = scope => {
      root.classList.add('rr-ready');
      scope.querySelectorAll('[data-rr-tools]').forEach(tool => { tool.hidden = false; });
      scope.querySelectorAll('[data-rr-reveal]').forEach(el => revealObserver.observe(el));
      scope.querySelectorAll('.rr-film').forEach(video => {
        if (players.has(video)) return;
        players.set(video, { visible: false, userPaused: false });
        const button = video.parentElement.querySelector('[data-rr-film-toggle]');
        if (button) {
          button.hidden = false;
          button.addEventListener('click', () => {
            const state = players.get(video);
            if (video.paused) { state.userPaused = false; play(video); }
            else { state.userPaused = true; video.pause(); }
          });
        }
        video.addEventListener('play', () => setButton(video, true));
        video.addEventListener('pause', () => setButton(video, false));
        videoObserver.observe(video);
      });
      scope.querySelectorAll('[data-rr-filter-group]').forEach(group => {
        if (group.dataset.ready) return;
        group.dataset.ready = 'true';
        const buttons = [...group.querySelectorAll('[data-rr-filter]')];
        const grid = group.closest('[data-rr-gallery]').querySelector('[data-rr-grid]');
        const update = button => {
          const filter = button.dataset.rrFilter;
          grid.dataset.activeFilter = filter;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          grid.querySelectorAll('[data-category]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
          const count = [...grid.children].filter(card=>!card.hidden).length;
          group.closest('[data-rr-gallery]').querySelector('[data-rr-count]').textContent = `${count} ${grid.dataset.countLabel}`;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          if (document.startViewTransition && motion) document.startViewTransition(() => update(button));
          else update(button);
        }));
      });
      scope.querySelectorAll('[data-rr-studio-form]').forEach(form => {
        if (form.dataset.ready) return;
        form.dataset.ready = 'true';
        const summary = form.querySelector('[data-rr-summary]');
        const update = () => { const data = new FormData(form); summary.textContent = [data.get('piece'),data.get('metal'),data.get('budget')].filter(Boolean).join(' / '); };
        form.addEventListener('change',update); update();
      });
      const params = new URLSearchParams(window.location.search);
      const contact = document.getElementById('ContactForm');
      if (contact) {
        [['piece','jewellery_type'],['metal','metal'],['budget','budget']].forEach(([param,field]) => {
          const input = contact.querySelector(`[name="contact[${field}]"]`);
          if (input && !input.value && params.has(param)) input.value = params.get(param).slice(0,160);
        });
      }
      applyMotion();
    };
    document.addEventListener('click', event => { if (event.target.closest('[data-rr-motion-toggle]')) { motion = !motion; applyMotion(); } });
    motionQuery.addEventListener('change',event => { motion = !event.matches; applyMotion(); });
    document.addEventListener('visibilitychange',applyMotion);
    document.addEventListener('shopify:section:load',event => init(event.target));
    document.addEventListener('shopify:section:unload',event => { players.forEach((state,video) => { if(event.target.contains(video)) { videoObserver.unobserve(video); video.pause(); players.delete(video); } }); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document));
    else init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
